<template>
  <div>
    <page-title>System Alerts</page-title>

    <loading v-if="loading" />

    <div v-else>
      <section-block>
        <template slot="actions">
          <base-button
            :primary="true"
            @click="$router.push({name: 'AdminAlertsAdd'})"
            iconBefore="document-create"
          >
            <span>Add a new alert</span>
          </base-button>
        </template>

        <vuetable
          class="c-data-table"
          :api-mode="false"
          :fields="table.fields"
          :data="alerts"
          :row-class="onRowClass"
          ref="alertsTable"
        >
          <template slot="date-created" slot-scope="props">
            <base-datetime :date="props.rowData.created_time"></base-datetime>
          </template>

          <template
            slot="persistent"
            slot-scope="props"
          >{{ props.rowData.persistent === 1 ? 'Yes' : 'No'}}</template>

          <template slot="actions" slot-scope="props">
            <base-button
              :primary="true"
              @click="$router.push({name: 'AdminAlertsEdit', params:{id: props.rowData.id}})"
            >Edit</base-button>
            <base-button danger @click="handleDelete(props.rowData.id)">Delete</base-button>
          </template>
        </vuetable>
      </section-block>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "AdminAlertsIndex",

  methods: {
    onRowClicked(rowdata) {
      this.$router.push({
        name: "AdminAlertsEdit",
        params: { id: rowdata.data.id }
      });
    },
    onRowClass(dataItem, index) {
      return dataItem.active ? "is-active" : "";
    },
    handleDelete(rowId) {
      const vm = this;
      this.$store.dispatch("createDialog", {
        confirm: () => {
          this.$store.dispatch("Alerts/deleteAlert", rowId).then(resp => {
            vm.$store.dispatch(
              "notifications/create",
              {
                body: `The alert was deleted`,
                type: "success"
              },
              { root: true }
            );
            setTimeout(() => {
              vm.$store.dispatch(`Alerts/list`);
            }, 1000); //temporary measure for now
          });
        }
      });
    }
  },

  data() {
    return {
      loading: true,
      table: {
        fields: [
          {
            name: "title",
            title: "Alert Title",
            titleClass: "u-ta-left",
            dataClass: "u-ta-left title-col",
            width: "25%"
          },
          {
            name: "persistent",
            title: "Persistent",
            titleClass: "u-ta-left",
            dataClass: "u-ta-left title-col",
            width: "25%"
          },
          {
            name: "date-created",
            title: "Date Added",
            titleClass: "u-ta-center",
            dataClass: "u-ta-center",
            width: "25%"
          },
          {
            name: "actions",
            title: "Actions",
            titleClass: "u-ta-center",
            dataClass: "u-ta-center",
            width: "25%"
          }
        ]
      }
    };
  },

  computed: {
    ...mapState("Alerts", ["alerts"])
  },

  created() {
    this.$store.dispatch("Alerts/list").then(resp => {
      this.loading = false;
    });
  }
};
</script>

<style lang="scss" scoped>
/deep/ .is-active {
  background: rgba($colour-nhs-light-blue, 0.1);
}
</style>